import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResultadosService {

  idEmpresa: string;
  idUsuario: string;
  nivel:number;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
  // this.obtienInfo();
  }

  obtienInfo(){
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    this.idEmpresa = infoUsu.empresaId;
    this.nivel = infoUsu.level;
  }

  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  getProdCertAct(){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }

  getNivel(){
    this.obtienInfo();
    return this.nivel;
  }

  getParamsTableau(datos:any,bandera?:any,idUsuario?:any){
    this.obtienInfo();
    if(bandera==1){
      console.log("Nuevo user");
      this.idUsuario=idUsuario;
      console.log(this.idUsuario);
    }
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getParamsTableau + this.idUsuario, datos);
  }

  getParamsTableauCovid(datos:any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getParamsTableauCovid, datos);
  }

  getCGO2EmpresasResults(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getCGO2EmpresasResults);
  }

  EnviaDatos(){
    let datos: any = {
      atoken: '999e72f4-ba5c-4906-aea2-8532488883d4',
      ctoken: '12345',
      email: 'ipg@gptwonline.com',
      utype:'1',
      brk:'1',
      pid:'',
      lang:'18'
    };
    return this.http.post('http://35.247.132.129/CGoReporting/index.jsp', datos);
  }

 get4allresul(dato){
   this.obtienInfo();
   return this.http.post(DATOS_API.url + DATOS_API.endpoints.resul4all.getresult4all+this.idEmpresa, dato);
 }
 get4allresulExterno(empresaId,dato){
   return this.http.post(DATOS_API.url + DATOS_API.endpoints.resul4all.getresult4all+empresaId, dato);
 }

 getresultallProducVer3(token){
   return this.http.get(DATOS_API.url + DATOS_API.endpoints.resul4all.getresultallProducVer3+ token);
 }

 getUsuariosEmpresas(nomEmpresa:any,instituto:any){
  console.log(nomEmpresa);
  console.log(instituto);
  return this.http.get(DATOS_API.url + DATOS_API.endpoints.getUsuariosEmpresas+nomEmpresa+"/"+instituto);
}

getMensajeResultModal(){
  return this.http.get(DATOS_API.url + DATOS_API.endpoints.mensajeResultModal);

}

getURLSuccessGo(empresaId:any,token:any, idProduct:any, broker:any, lang:any, user:any){
  // return this.http.get(DATOS_API.url + DATOS_API.endpoints.getURLSuccessGo+empresaId+"/"+token+"/"+idProduct+"/"+broker+"/"+lang+"/"+user);
  return this.http.get(DATOS_API.url + DATOS_API.endpoints.getURLSuccessGo+token+"/"+broker+"/"+lang+"/"+user);

}
getURLGoGCTI(empresaId:any,token:any, idProduct:any, broker:any, lang:any, user:any){
  return this.http.get(DATOS_API.url + DATOS_API.endpoints.getGetURLSuccessGoGCTI+token+"/"+broker+"/"+lang+"/"+user);

}
getFlagSuccesGo(){
  return this.http.get(DATOS_API.url + DATOS_API.endpoints.getFlagSuccesGo);
}

getURLSuccessGoV3(empresaId:any,token:any, idProduct:any, broker:any, lang:any, user:any,flag:any){
  // return this.http.get(DATOS_API.url + DATOS_API.endpoints.getURLSuccessGo+empresaId+"/"+token+"/"+idProduct+"/"+broker+"/"+lang+"/"+user);
  return this.http.get(DATOS_API.url + DATOS_API.endpoints.getURLSuccessGoV3+token+"/"+broker+"/"+lang+"/"+user+"/"+flag);

}
getURLSuccessGoV4(empresaId:any,token:any, idProduct:any, broker:any, lang:any, user:any,flag:any,version:any){
  // return this.http.get(DATOS_API.url + DATOS_API.endpoints.getURLSuccessGo+empresaId+"/"+token+"/"+idProduct+"/"+broker+"/"+lang+"/"+user);
  return this.http.get(DATOS_API.url + DATOS_API.endpoints.getURLSuccessGoV4+token+"/"+broker+"/"+lang+"/"+user+"/"+flag+"/"+version);

}

getBanderasProducto(idEmpresa: string, idProducto: string){
  return this.http.get(DATOS_API.url + DATOS_API.endpoints.configuracionProducto.getBanderasConfiguracion + idEmpresa + "/" + idProducto);
}
 }
